import * as React from "react"
import { TranslatorContext } from "components/Translator/TranslatorContext"

export const useTranslator = () => {
  const Translator = React.useContext(TranslatorContext)
  return Translator
}
